"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalProvider = exports.ModalContext = exports.focusReducer = exports.modalReducer = exports.focusReducerTypes = exports.modalReducerTypes = void 0;
var React = require("react");
var Modals_1 = require("../components/Modals");
var defaultModalState = {
    stack: [],
    stopClickOnOutside: false,
};
var ModalContext = React.createContext({
    data: defaultModalState,
    spawnModal: function (content) { },
    despawnModal: function () { },
    despawnAllModals: function () { },
    opts: undefined,
});
exports.ModalContext = ModalContext;
exports.modalReducerTypes = {
    spawnModal: "SPAWN_MODAL",
    despawnModal: "DESPAWN_MODAL",
    despawnAllModals: "DESPAWN_ALL_MODALS",
};
exports.focusReducerTypes = {
    addFocusElement: "ADD_FOCUS_ELEM",
    removeFocusElement: "REMOVE_FOCUS_ELEM",
    focusFirstElement: "FOCUS_FIRST_ELEMENT",
};
function modalReducer(state, action) {
    switch (action.type) {
        case exports.modalReducerTypes.spawnModal:
            return __assign(__assign({}, state), { stack: __spreadArray(__spreadArray([], state.stack), [
                    {
                        content: action.content,
                        fullscreen: !!action.fullscreen,
                    },
                ]) });
        case exports.modalReducerTypes.despawnModal:
            var stackCopy = __spreadArray([], state.stack);
            stackCopy.pop();
            return __assign(__assign({}, state), { stack: stackCopy });
        case exports.modalReducerTypes.despawnAllModals:
            return __assign(__assign({}, state), { stack: [] });
        default:
            return state;
    }
}
exports.modalReducer = modalReducer;
function focusReducer(state, action) {
    switch (action.type) {
        case exports.focusReducerTypes.addFocusElement:
            return __spreadArray(__spreadArray([], state), [
                {
                    element: action.element,
                },
            ]);
        case exports.focusReducerTypes.removeFocusElement:
            var focusElementsCopy = __spreadArray([], state);
            var elementToFocus_1 = focusElementsCopy[focusElementsCopy.length - 1];
            if (!!elementToFocus_1.element) {
                window.setTimeout(function () {
                    // @ts-ignore
                    elementToFocus_1.element.focus();
                }, 10);
            }
            focusElementsCopy.pop();
            return focusElementsCopy;
        case exports.focusReducerTypes.focusFirstElement:
            if (!!state[0].element) {
                window.setTimeout(function () {
                    // @ts-ignore
                    state[0].element.focus();
                }, 10);
            }
            return [];
        default:
            return state;
    }
}
exports.focusReducer = focusReducer;
var ModalHelperProvider = function (_a) {
    var children = _a.children, opts = _a.opts;
    var _b = React.useReducer(modalReducer, defaultModalState), modalState = _b[0], modalDispatcher = _b[1];
    var _c = React.useReducer(focusReducer, []), focusDispatcher = _c[1];
    function spawnModal(content, fullscreen) {
        focusDispatcher({
            type: exports.focusReducerTypes.addFocusElement,
            element: document.activeElement,
        });
        modalDispatcher({
            type: exports.modalReducerTypes.spawnModal,
            content: content,
            fullscreen: fullscreen,
        });
    }
    function despawnModal() {
        modalDispatcher({ type: exports.modalReducerTypes.despawnModal });
        focusDispatcher({ type: exports.focusReducerTypes.removeFocusElement });
    }
    function despawnAllModals() {
        modalDispatcher({ type: exports.modalReducerTypes.despawnAllModals });
        focusDispatcher({ type: exports.focusReducerTypes.focusFirstElement });
    }
    return (React.createElement(ModalContext.Provider, { value: {
            data: modalState,
            spawnModal: spawnModal,
            despawnModal: despawnModal,
            despawnAllModals: despawnAllModals,
            opts: opts,
        } }, children));
};
var ModalProvider = function (_a) {
    var children = _a.children, opts = _a.opts;
    return (React.createElement(ModalHelperProvider, { opts: opts },
        React.createElement(Modals_1.default, null),
        children));
};
exports.ModalProvider = ModalProvider;
//# sourceMappingURL=Modal.js.map